// @ts-nocheck
import React, { useState, useEffect } from 'react';
import { renderEmail, renderBlock, defaultBlock, withHeaderFooter, withFontFamily, BLOCK_LIBRARY, FONT_OPTIONS, COLOR_SWATCHES } from './emailBlocks';

export default function EmailBuilder({
  initialBlocks = [], templateName = '', onSaveBlocks, onBack, gallery = [], onUpload, onLoadGallery, onDeletePhoto,
  templates = [], onLoadTemplates, onPickTemplate, onNewBlank,
  docs = [], onLoadDocs, onPickDoc, onNewDoc, onSaveDoc, onTranslate, onDeleteDoc, initialDocMode = false,
  contacts = [], onLoadContacts, onAddContact, onDeleteContact,
  prContacts = [], onLoadPrContacts,
  recipients = [], onLoadRecipients, onSend, onSearchCharter,
}) {
  // Blank built-in → ξεκινά ΑΔΕΙΟ (χωρίς header/footer). «Νέο πρότυπο» / άλλα templates → header+footer.
  // withFontFamily τρέχει πάντα. (templateName έρχεται φρέσκο από openTemplate σε κάθε remount.)
  const seeded = (templateName === 'Blank / Free Build') ? initialBlocks : withHeaderFooter(initialBlocks);
  const [blocks, setBlocks] = useState(withFontFamily(seeded));
  const [selId, setSelId] = useState(null);
  const [panel, setPanel] = useState('blocks');
  const [docMode, setDocMode] = useState(!!initialDocMode);
  const [translating, setTranslating] = useState(false);
  const [showLangPick, setShowLangPick] = useState(false);
  const EB_LANGS = [['el','🇬🇷'],['en','🇬🇧'],['it','🇮🇹'],['de','🇩🇪'],['ru','🇷🇺'],['fr','🇫🇷'],['ro','🇷🇴'],['pl','🇵🇱'],['he','🇮🇱'],['es','🇪🇸']];
  const [name, setName] = useState(templateName || 'Νέο πρότυπο');

  // contacts panel form
  const [cName, setCName] = useState('');
  const [cEmail, setCEmail] = useState('');
  const [cType, setCType] = useState('customer');
  // send panel
  const [sendTplId, setSendTplId] = useState('');
  const [recipTab, setRecipTab] = useState('customer');
  const [recipChecked, setRecipChecked] = useState({});
  const [pdfName, setPdfName] = useState('');
  const [prCode, setPrCode] = useState('');
  const [prRecipient, setPrRecipient] = useState(null);
  const [prLoading, setPrLoading] = useState(false);
  // default-check all recipients whenever the list changes
  useEffect(() => {
    const ck = {}; (recipients || []).forEach(c => { ck[c.email] = true; });
    setRecipChecked(ck);
  }, [recipients]);
  const sendCount = (recipients || []).filter(c => recipChecked[c.email]).length;
  const sendTpl = (templates || []).find(t => String(t.id) === String(sendTplId));
  const isPR = sendTpl?.type === 'payment_reminder' || sendTpl?.type === 'payment_confirmation';

  const sel = blocks.find(b => b.id === selId) || null;

  function addBlock(type) {
    const nb = defaultBlock(type);
    setBlocks(prev => [...prev, nb]);
    setSelId(nb.id);
  }
  function delBlock(id) {
    setBlocks(prev => prev.filter(b => b.id !== id));
    if (selId === id) setSelId(null);
  }
  function moveBlock(id, dir) {
    setBlocks(prev => {
      const i = prev.findIndex(b => b.id === id);
      if (i < 0) return prev;
      const j = dir === 'up' ? i - 1 : i + 1;
      if (j < 0 || j >= prev.length) return prev;
      const cp = [...prev];
      [cp[i], cp[j]] = [cp[j], cp[i]];
      return cp;
    });
  }
  function updateProp(key, val) {
    setBlocks(prev => prev.map(b => b.id === selId ? { ...b, props: { ...b.props, [key]: val } } : b));
  }
  async function pdfToBase64(file) {
    return new Promise((res, rej) => {
      const r = new FileReader();
      r.onload = () => res(String(r.result).split(',')[1]);
      r.onerror = rej;
      r.readAsDataURL(file);
    });
  }

  const html = renderEmail(blocks);
  const MENU = [
    { key: 'documents', icon: '📄', label: 'Έγγραφα' },
    { key: 'templates', icon: '📋', label: 'Πρότυπα' },
    { key: 'blocks', icon: '➕', label: 'Μπλοκ' },
    { key: 'gallery', icon: '🖼️', label: 'Γκαλερί' },
    { key: 'color', icon: '🎨', label: 'Χρώμα' },
    { key: 'font', icon: '🔤', label: 'Γραμματοσειρά' },
    { key: 'size', icon: '🔠', label: 'Μέγεθος' },
    { key: 'align', icon: '↔️', label: 'Στοίχιση' },
    { key: 'settings', icon: '⚙️', label: 'Ρυθμίσεις' },
    { key: 'contacts', icon: '👥', label: 'Επαφές' },
    { key: 'send', icon: '📤', label: 'Αποστολή' },
  ];

  function onMenuClick(key) {
    if (panel === key) { setPanel(null); return; } // ξανα-πάτημα ίδιου = κλείσε
    setPanel(key);
    if (key === 'documents') onLoadDocs && onLoadDocs();
    else if (key === 'gallery') onLoadGallery && onLoadGallery();
    else if (key === 'templates') onLoadTemplates && onLoadTemplates();
    else if (key === 'contacts') onLoadContacts && onLoadContacts();
    else if (key === 'send') { onLoadTemplates && onLoadTemplates(); onLoadRecipients && onLoadRecipients(recipTab); onLoadContacts && onLoadContacts(); onLoadPrContacts && onLoadPrContacts(); }
  }

  return (
    <div style={{ minHeight: '100vh', background: '#f1f5f9', display: 'flex', flexDirection: 'column' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 16px', background: '#fff', borderBottom: '1px solid #e2e8f0' }}>
        <button onClick={onBack} style={btnGhost}>← Πίσω / Back</button>
        <input value={name} onChange={e => setName(e.target.value)} style={{ ...inp, maxWidth: 280, fontWeight: 700 }} />
        {docMode && onTranslate && (
          <div style={{ position: 'relative', marginLeft: 'auto' }}>
            <button onClick={() => { if (!selId) { window.alert('Διάλεξε πρώτα ένα μπλοκ στον καμβά.'); return; } setShowLangPick(v => !v); }} disabled={translating} style={{ ...btnPrimary, background: translating ? '#94a3b8' : '#7c3aed' }}>{translating ? '🌐 Μετάφραση…' : '🌐 Μετάφραση'}</button>
            {showLangPick && !translating && (
              <div style={{ position: 'absolute', top: '110%', right: 0, background: '#fff', border: '1px solid #e2e8f0', borderRadius: 8, padding: 8, boxShadow: '0 4px 12px rgba(0,0,0,0.15)', zIndex: 50, display: 'flex', flexWrap: 'wrap', gap: 4, width: 200 }}>
                <button onClick={async () => { setShowLangPick(false); setTranslating(true); try { await onTranslate(selId, 'all', blocks); } catch (e) {} setTranslating(false); }} style={{ padding: '6px 10px', borderRadius: 6, border: '1px solid #cbd5e1', cursor: 'pointer', width: '100%', fontWeight: 700, background: '#7c3aed', color: '#fff' }}>🌍 Όλες</button>
                {EB_LANGS.map(([lg, fl]) => (
                  <button key={lg} onClick={async () => { setShowLangPick(false); setTranslating(true); try { await onTranslate(selId, lg, blocks); } catch (e) {} setTranslating(false); }} style={{ borderRadius: 6, border: '1px solid #cbd5e1', cursor: 'pointer', background: '#fff', fontSize: 18, padding: '4px 8px' }} title={lg}>{fl}</button>
                ))}
              </div>
            )}
          </div>
        )}
        <button onClick={() => { if (docMode) { onSaveDoc && onSaveDoc(blocks, html, name); } else { onSaveBlocks && onSaveBlocks(blocks, html, name); } }} style={{ ...btnPrimary, marginLeft: docMode && onTranslate ? 0 : 'auto' }}>💾 Αποθήκευση / Save</button>
      </div>

      <div style={{ display: 'flex', flex: 1, minHeight: 0 }}>
        <div style={{ width: 168, background: '#0d2840', display: 'flex', flexDirection: 'column', padding: '10px 8px', gap: 2 }}>
          {MENU.map(m => (
            <MenuItem key={m.key} icon={m.icon} label={m.label} active={panel === m.key}
              onClick={() => onMenuClick(m.key)} />
          ))}
        </div>

        {panel !== null && (
        <div style={{ width: 230, background: '#fff', borderRight: '1px solid #e2e8f0', padding: 14, overflowY: 'auto' }}>
          {panel === 'documents' && (
            <>
              <p style={ptitle}>📄 Έγγραφα</p>
              <button onClick={() => { setDocMode(true); onNewDoc && onNewDoc(); }} style={{ ...btnPrimary, width: '100%', marginBottom: 10 }}>✚ Νέο έγγραφο</button>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                {(docs || []).length === 0 && <span style={{ fontSize: 12, color: '#94a3b8' }}>Κανένα / None</span>}
                {(docs || []).map(d => (
                  <div key={d.id} style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                    <button onClick={() => { setDocMode(true); onPickDoc && onPickDoc(d); }} style={{ ...blockBtn, flex: 1, textAlign: 'left' }}>
                      <span style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{d.name}</span>
                    </button>
                    <button onClick={() => { if (window.confirm('Διαγραφή εγγράφου;')) onDeleteDoc && onDeleteDoc(d); }} title="Διαγραφή" style={{ padding: '4px 8px', borderRadius: 6, border: '1px solid #fecaca', background: '#fff', color: '#dc2626', cursor: 'pointer' }}>🗑</button>
                  </div>
                ))}
              </div>
            </>
          )}
          {panel === 'templates' && (
            <>
              <p style={ptitle}>📋 Πρότυπα</p>
              <button onClick={() => { setDocMode(false); onNewBlank && onNewBlank(); }} style={{ ...btnPrimary, width: '100%', marginBottom: 10 }}>✚ Νέο</button>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                {(templates || []).length === 0 && <span style={{ fontSize: 12, color: '#94a3b8' }}>Καμία / None</span>}
                {(templates || []).map(t => (
                  <button key={t.id} onClick={() => { setDocMode(false); onPickTemplate && onPickTemplate(t); }} style={blockBtn}>
                    <span style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{t.name}</span>
                  </button>
                ))}
              </div>
            </>
          )}

          {panel === 'blocks' && (
            <>
              <p style={ptitle}>Έτοιμα μπλοκ</p>
              <p style={{ fontSize: 11, color: '#94a3b8', margin: '0 0 10px' }}>Πάτησε για προσθήκη στον καμβά</p>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                {BLOCK_LIBRARY.map(b => (
                  <button key={b.type} onClick={() => addBlock(b.type)} style={blockBtn}>
                    <span style={{ fontSize: 18, marginRight: 8 }}>{b.icon}</span> {b.label}
                  </button>
                ))}
              </div>
            </>
          )}

          {panel === 'gallery' && (
            <>
              <p style={ptitle}>Γκαλερί φωτό</p>
              <label style={{ ...btnSecondary, display: 'block', textAlign: 'center', marginBottom: 10 }}>
                📷 Ανέβασμα / Upload
                <input type="file" accept="image/*" style={{ display: 'none' }} onChange={e => onUpload && onUpload(e.target.files && e.target.files[0])} />
              </label>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6 }}>
                {gallery.length === 0 && <span style={{ fontSize: 12, color: '#94a3b8' }}>Καμία φωτό / No photos</span>}
                {gallery.map(g => (
                  <div key={g.url} style={{ position: 'relative' }}>
                    <img src={g.url} alt="" title="κλικ: βάλε σε επιλεγμένο μπλοκ"
                      onClick={() => { if (sel && sel.type === 'image') updateProp('url', g.url); else if (sel && sel.type === 'yacht') updateProp('photoUrl', g.url); }}
                      style={{ width: '100%', height: 60, objectFit: 'cover', borderRadius: 6, cursor: 'pointer', border: '1px solid #e2e8f0' }} />
                    <button onClick={() => { if (window.confirm('Διαγραφή φωτό; / Delete photo?')) onDeletePhoto && onDeletePhoto(g.name); }}
                      title="Διαγραφή φωτό"
                      style={{ position: 'absolute', top: 2, right: 2, background: 'rgba(254,226,226,0.95)', color: '#b91c1c', border: 'none', borderRadius: 4, width: 22, height: 22, cursor: 'pointer', fontSize: 11, lineHeight: 1 }}>🗑</button>
                  </div>
                ))}
              </div>
              <p style={{ fontSize: 11, color: '#94a3b8', marginTop: 8 }}>Διάλεξε μπλοκ Φωτό/Σκάφος, μετά κλικ σε φωτό.</p>
            </>
          )}

          {panel === 'color' && <StylePanel title="🎨 Χρώμα" sel={sel}>
            {sel && ('color' in sel.props) && <Swatches label="Χρώμα κειμένου" cur={sel.props.color} onPick={c => updateProp('color', c)} />}
            {sel && ('bg' in sel.props) && <Swatches label="Χρώμα φόντου" cur={sel.props.bg} onPick={c => updateProp('bg', c)} />}
            {sel && !('color' in sel.props) && !('bg' in sel.props) && <Nope />}
          </StylePanel>}

          {panel === 'font' && <StylePanel title="🔤 Γραμματοσειρά" sel={sel}>
            {sel && ('fontFamily' in sel.props)
              ? <select value={sel.props.fontFamily || 'Arial,sans-serif'} onChange={e => updateProp('fontFamily', e.target.value)} style={inp}>{FONT_OPTIONS.map(f => <option key={f} value={f}>{f.split(',')[0].replace(/"/g, '')}</option>)}</select>
              : <Nope />}
          </StylePanel>}

          {panel === 'size' && <StylePanel title="🔠 Μέγεθος" sel={sel}>
            {sel && ('fontSize' in sel.props)
              ? <><label style={lbl}>{sel.props.fontSize}px</label><input type="range" min="11" max="42" value={sel.props.fontSize} onChange={e => updateProp('fontSize', +e.target.value)} style={{ width: '100%' }} /></>
              : <Nope />}
          </StylePanel>}

          {panel === 'align' && <StylePanel title="↔️ Στοίχιση" sel={sel}>
            {sel && ('align' in sel.props)
              ? <div style={{ display: 'flex', gap: 6 }}>
                  {['left', 'center', 'right'].map(a => <button key={a} onClick={() => updateProp('align', a)} style={{ ...blockBtn, flex: 1, justifyContent: 'center', background: sel.props.align === a ? '#1e88e5' : '#f8fafc', color: sel.props.align === a ? '#fff' : '#0d2840' }}>{a === 'left' ? 'Αρ.' : a === 'center' ? 'Κέντ.' : 'Δεξ.'}</button>)}
                </div>
              : <Nope />}
          </StylePanel>}

          {panel === 'settings' && <BlockSettings sel={sel} updateProp={updateProp} gallery={gallery} />}

          {panel === 'contacts' && (
            <>
              <p style={ptitle}>👥 Επαφές</p>
              <div style={{ marginBottom: 12 }}>
                <input placeholder="Όνομα" value={cName} onChange={e => setCName(e.target.value)} style={{ ...inp, marginBottom: 4 }} />
                <input placeholder="email@..." value={cEmail} onChange={e => setCEmail(e.target.value)} style={{ ...inp, marginBottom: 4 }} />
                <select value={cType} onChange={e => setCType(e.target.value)} style={{ ...inp, marginBottom: 4 }}>
                  <option value="customer">Πελάτης</option>
                  <option value="broker">Συνεργάτης</option>
                </select>
                <button onClick={() => {
                  const em = cEmail.trim();
                  if (!em) return;
                  onAddContact && onAddContact({ name: cName.trim(), email: em, type: cType });
                  setCName(''); setCEmail('');
                }} style={{ ...btnSecondary, width: '100%' }}>+ Προσθήκη</button>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                {(contacts || []).length === 0 && <span style={{ fontSize: 12, color: '#94a3b8' }}>Καμία / None</span>}
                {(contacts || []).map(c => (
                  <div key={c.id || c.email} style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, padding: '5px 0', borderBottom: '1px solid #f1f5f9' }}>
                    <span style={{ flex: 1, minWidth: 0 }}>
                      <strong style={{ color: '#0d2840' }}>{((c.first_name || '') + ' ' + (c.last_name || '')).trim() || '—'}</strong><br />
                      <span style={{ color: '#64748b' }}>{c.email}</span>
                    </span>
                    {c.id && <button onClick={() => onDeleteContact && onDeleteContact(c.id)} style={{ ...ctrlBtn, background: '#fee2e2', color: '#b91c1c' }}>🗑</button>}
                  </div>
                ))}
              </div>
            </>
          )}

          {panel === 'send' && (
            <>
              <p style={ptitle}>📤 Αποστολή</p>
              <label style={lbl}>Πρότυπο προς αποστολή</label>
              <select value={sendTplId} onChange={e => setSendTplId(e.target.value)} style={{ ...inp, marginBottom: 10 }}>
                <option value="">— Διάλεξε πρότυπο —</option>
                {(templates || []).map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
              </select>
              {isPR && (
                <div style={{ background: '#f4f8fc', borderRadius: 8, padding: 12, marginBottom: 12 }}>
                  <label style={lbl}>🔍 Κωδικός Ναύλου</label>
                  <div style={{ display: 'flex', gap: 6, marginBottom: 8 }}>
                    <input value={prCode} onChange={e => setPrCode(e.target.value)} placeholder="π.χ. 451" style={{ ...inp, marginBottom: 0, flex: 1 }} />
                    <button onClick={async () => { setPrLoading(true); const r = onSearchCharter && await onSearchCharter(prCode); setPrRecipient(r); if (r) { const isPC = sendTpl?.type === 'payment_confirmation'; const paidFull = parseFloat(r.balance || '0') <= 0; setBlocks(prev => prev.map(b => { if (b.type === 'paymentBox') return { ...b, props: { ...b.props, vessel: r.vessel, charterCode: r.charter_code, startDate: r.start_date, endDate: r.end_date, balance: r.balance } }; if (isPC && b.id === 'pc_body') return { ...b, props: { ...b.props, text: paidFull ? 'Thank you for completing your payment. Your booking is now fully paid.' : 'Thank you for your payment. The remaining balance is shown above.' } }; if (b.props && typeof b.props.text === 'string') return { ...b, props: { ...b.props, text: b.props.text.replace(/\{\{vessel\}\}/g, r.vessel||'').replace(/\{\{charterCode\}\}/g, r.charter_code||'').replace(/\{\{startDate\}\}/g, r.start_date||'').replace(/\{\{endDate\}\}/g, r.end_date||'').replace(/\{\{balance\}\}/g, r.balance||'') } }; return b; })); } setPrLoading(false); }} style={{ ...blockBtn, justifyContent: 'center' }}>{prLoading ? '...' : '🔍 Αναζήτηση'}</button>
                  </div>
                  {prRecipient && (
                    <div style={{ fontSize: 13, color: '#0d2840', lineHeight: 1.7 }}>
                      <div><strong>Σκάφος:</strong> {prRecipient.vessel || '—'}</div>
                      <div><strong>Ναύλος:</strong> {prRecipient.charter_code || '—'}</div>
                      <div><strong>Περίοδος:</strong> {prRecipient.start_date} – {prRecipient.end_date}</div>
                      <div><strong>Υπόλοιπο:</strong> <span style={{ color: '#c0392b', fontWeight: 'bold' }}>{prRecipient.balance} €</span></div>
                      {(prRecipient.chartererEmail || prRecipient.brokerEmail) && (
                        <div style={{ marginTop: 8 }}>
                          <label style={lbl}>Επιλογή Παραλήπτη</label>
                          <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                            {prRecipient.chartererEmail && (
                              <button onClick={() => setPrRecipient({ ...prRecipient, email: prRecipient.chartererEmail, contact_type: 'customer', first_name: prRecipient.chartererFirstName, last_name: prRecipient.chartererLastName })} style={{ ...blockBtn, justifyContent: 'flex-start', background: prRecipient.email === prRecipient.chartererEmail ? '#1e88e5' : '#f8fafc', color: prRecipient.email === prRecipient.chartererEmail ? '#fff' : '#0d2840' }}>👤 Πελάτης: {((prRecipient.first_name || '') + ' ' + (prRecipient.last_name || '')).trim()} — {prRecipient.chartererEmail}</button>
                            )}
                            {prRecipient.brokerEmail && (
                              <button onClick={() => setPrRecipient({ ...prRecipient, email: prRecipient.brokerEmail, contact_type: 'broker', company_name: prRecipient.brokerName, first_name: prRecipient.brokerName, last_name: '' })} style={{ ...blockBtn, justifyContent: 'flex-start', background: prRecipient.email === prRecipient.brokerEmail ? '#1e88e5' : '#f8fafc', color: prRecipient.email === prRecipient.brokerEmail ? '#fff' : '#0d2840' }}>🏢 Agency: {prRecipient.brokerName || '—'} — {prRecipient.brokerEmail}</button>
                            )}
                          </div>
                        </div>
                      )}
                      {(prContacts || []).length > 0 && (
                        <div style={{ marginTop: 8 }}>
                          <label style={lbl}>Από επαφές (Πελάτες & Brokers)</label>
                          <select value="" onChange={e => { const sel = (prContacts || []).find(c => c.email === e.target.value); if (sel) { if (sel.contact_type === 'broker') { setPrRecipient({ ...prRecipient, email: sel.email, contact_type: 'broker', company_name: sel.company_name || '', first_name: sel.company_name || '', last_name: '' }); } else { setPrRecipient({ ...prRecipient, email: sel.email, contact_type: 'customer', company_name: '', first_name: sel.first_name || sel.name || '', last_name: sel.last_name || '' }); } } }} style={{ ...inp, marginBottom: 0 }}>
                            <option value="">— Διάλεξε επαφή —</option>
                            <optgroup label="Πελάτες">
                              {(prContacts || []).filter(c => c.contact_type !== 'broker').map(c => (
                                <option key={'c_' + (c.id || c.email)} value={c.email}>{(((c.first_name || '') + ' ' + (c.last_name || '')).trim() || c.name || c.email)} — {c.email}</option>
                              ))}
                            </optgroup>
                            <optgroup label="Broker / Agency">
                              {(prContacts || []).filter(c => c.contact_type === 'broker').map(c => (
                                <option key={'b_' + (c.id || c.email)} value={c.email}>{((c.company_name || ((c.first_name || '') + ' ' + (c.last_name || '')).trim()) || c.email)} — {c.email}</option>
                              ))}
                            </optgroup>
                          </select>
                        </div>
                      )}
                      <label style={{ ...lbl, marginTop: 8 }}>Email Παραλήπτη</label>
                      <input value={prRecipient.email} onChange={e => setPrRecipient({ ...prRecipient, email: e.target.value })} placeholder="email πελάτη" style={{ ...inp, marginBottom: 0 }} />
                    </div>
                  )}
                </div>
              )}
              {!isPR && (<>
              <div style={{ display: 'flex', gap: 4, marginBottom: 8 }}>
                {[['customer', 'Πελάτες'], ['broker', 'Συνεργάτες']].map(([k, label]) => (
                  <button key={k} onClick={() => { setRecipTab(k); onLoadRecipients && onLoadRecipients(k); }}
                    style={{ ...blockBtn, flex: 1, justifyContent: 'center', background: recipTab === k ? '#1e88e5' : '#f8fafc', color: recipTab === k ? '#fff' : '#0d2840' }}>{label}</button>
                ))}
              </div>
              <div style={{ display: 'flex', gap: 6, marginBottom: 6 }}>
                <button onClick={() => { const ck = {}; (recipients || []).forEach(c => { ck[c.email] = true; }); setRecipChecked(ck); }} style={btnMini}>Όλοι</button>
                <button onClick={() => setRecipChecked({})} style={btnMini}>Κανείς</button>
              </div>
              <div style={{ maxHeight: 220, overflowY: 'auto', marginBottom: 10 }}>
                {(recipients || []).length === 0 && <span style={{ fontSize: 12, color: '#94a3b8' }}>Καμία επαφή / None</span>}
                {(recipients || []).map((c, i) => (
                  <label key={c.email + i} style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, padding: '3px 0', cursor: 'pointer' }}>
                    <input type="checkbox" checked={!!recipChecked[c.email]} onChange={() => setRecipChecked(p => ({ ...p, [c.email]: !p[c.email] }))} />
                    <span style={{ flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{((c.first_name || '') + ' ' + (c.last_name || '')).trim()} · {c.email}</span>
                  </label>
                ))}
              </div>
              </>)}
              <div style={{ marginTop: 12, marginBottom: 8 }}>
                <label style={lbl}>📎 Επισύναψη PDF (προαιρετικό)</label>
                <input type="file" accept="application/pdf" style={{ fontSize: 12 }} onChange={async e => {
                  const f = e.target.files && e.target.files[0];
                  if (!f) { window.__emailPdfAttach = []; setPdfName(''); return; }
                  const b64 = await pdfToBase64(f);
                  window.__emailPdfAttach = [{ filename: f.name, content: b64, contentType: 'application/pdf' }];
                  setPdfName(f.name);
                }} />
                {pdfName && <div style={{ fontSize: 12, color: '#0d2840', marginTop: 4 }}>📎 {pdfName}</div>}
              </div>
              <button onClick={() => {
                if (isPR) { if (prRecipient && prRecipient.email) onSend && onSend(sendTplId, [prRecipient], html); return; }
                const list = (recipients || []).filter(c => recipChecked[c.email]);
                onSend && onSend(sendTplId, list);
              }} disabled={isPR ? (!prRecipient || !prRecipient.email) : (!sendTplId || sendCount === 0)} style={{ ...btnPrimary, width: '100%', opacity: (isPR ? (prRecipient && prRecipient.email) : (sendTplId && sendCount)) ? 1 : 0.5 }}>
                📤 Αποστολή {isPR ? '' : `(${sendCount})`}
              </button>
            </>
          )}
        </div>
        )}

        <div style={{ flex: 1, padding: 16, overflowY: 'auto', background: '#e8eef4' }}>
          <p style={{ fontSize: 12, color: '#64748b', textAlign: 'center', margin: '0 0 10px' }}>Καμβάς — πάτησε μπλοκ για επεξεργασία</p>
          <div style={{ maxWidth: 600, margin: '0 auto', background: '#fff', borderRadius: 8, overflow: 'hidden', boxShadow: '0 1px 4px rgba(0,0,0,0.1)' }}>
            {blocks.length === 0 && <div style={{ padding: 40, textAlign: 'center', color: '#94a3b8', fontSize: 13 }}>Πρόσθεσε μπλοκ από αριστερά →</div>}
            {blocks.map(b => (
              <div key={b.id} onClick={() => setSelId(selId === b.id ? null : b.id)}
                style={{ position: 'relative', border: selId === b.id ? '2px solid #1e88e5' : '2px solid transparent', cursor: 'pointer' }}>
                {selId === b.id && (
                  <div style={{ position: 'absolute', top: 4, right: 4, display: 'flex', gap: 3, zIndex: 2 }}>
                    <button onClick={e => { e.stopPropagation(); moveBlock(b.id, 'up'); }} style={ctrlBtn}>↑</button>
                    <button onClick={e => { e.stopPropagation(); moveBlock(b.id, 'down'); }} style={ctrlBtn}>↓</button>
                    <button onClick={e => { e.stopPropagation(); delBlock(b.id); }} style={{ ...ctrlBtn, background: '#fee2e2', color: '#b91c1c' }}>🗑</button>
                  </div>
                )}
                {selId === b.id && (b.type === 'headline' || b.type === 'text') ? (
                  <div
                    contentEditable
                    suppressContentEditableWarning
                    onClick={e => e.stopPropagation()}
                    onBlur={e => updateProp('text', e.currentTarget.innerText)}
                    style={{ outline: '2px dashed #1e88e5', padding: b.type === 'headline' ? '18px 40px' : '10px 40px', minHeight: 24, fontFamily: b.props.fontFamily || 'Arial,sans-serif', fontSize: (b.props.fontSize || (b.type === 'headline' ? 26 : 15)), color: b.props.color || (b.type === 'headline' ? '#0d2840' : '#4a5a68'), textAlign: b.props.align || (b.type === 'headline' ? 'center' : 'left'), fontWeight: b.type === 'headline' ? 'bold' : 'normal', whiteSpace: 'pre-wrap' }}
                  >
                    {b.props.text || ''}
                  </div>
                ) : (
                  <div dangerouslySetInnerHTML={{ __html: blockPreviewHtml(b) }} />
                )}
              </div>
            ))}
          </div>
        </div>

        <div style={{ width: 320, background: '#fff', borderLeft: '1px solid #e2e8f0', padding: 12, overflowY: 'auto' }}>
          <p style={ptitle}>Προεπισκόπηση (πλήρες πλάτος 600px)</p>
          {/* scale-to-fit: render the email at its real 600px width, then shrink to the 296px panel so the whole width shows */}
          <div style={{ width: 296, height: 720, overflow: 'hidden', border: '1px solid #e2e8f0', borderRadius: 6, background: '#fff' }}>
            <iframe title="prev" srcDoc={html}
              style={{ width: 600, height: 1460, border: 'none', transform: 'scale(0.4933)', transformOrigin: 'top left' }} />
          </div>
        </div>
      </div>
    </div>
  );
}

function MenuItem({ icon, label, active, onClick }) {
  return (
    <button onClick={onClick} style={{ display: 'flex', alignItems: 'center', gap: 10, background: active ? '#1e3a5f' : 'transparent', border: 'none', color: active ? '#fff' : '#a9bccd', width: '100%', padding: '10px 12px', cursor: 'pointer', borderRadius: 8, textAlign: 'left' }}>
      <span style={{ fontSize: 18, width: 22, textAlign: 'center' }}>{icon}</span>
      <span style={{ fontSize: 13, fontWeight: 600 }}>{label}</span>
    </button>
  );
}

function StylePanel({ title, sel, children }) {
  return <><p style={ptitle}>{title}</p>{!sel ? <p style={{ fontSize: 13, color: '#94a3b8' }}>Διάλεξε μπλοκ στον καμβά.</p> : children}</>;
}
function Nope() { return <p style={{ fontSize: 12, color: '#94a3b8' }}>Αυτό το μπλοκ δεν το υποστηρίζει.</p>; }
function Swatches({ label, cur, onPick }) {
  const val = cur || '#000000';
  return <div style={{ marginBottom: 12 }}><label style={lbl}>{label}</label>
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
      <input type="color" value={val} onChange={e => onPick(e.target.value)} style={{ width: 42, height: 30, padding: 0, border: '1px solid #cbd5e1', borderRadius: 4, cursor: 'pointer', background: '#fff' }} />
      <span style={{ fontSize: 12, color: '#475569', fontFamily: 'monospace' }}>{val}</span>
    </div>
    <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
      {COLOR_SWATCHES.map(c => <span key={c} onClick={() => onPick(c)} style={{ width: 24, height: 24, borderRadius: 4, background: c, border: cur === c ? '2px solid #1e88e5' : '1px solid #cbd5e1', cursor: 'pointer' }} />)}
    </div></div>;
}

const Field = ({ label, children }) => <div style={{ marginBottom: 10 }}><label style={lbl}>{label}</label>{children}</div>;

function BlockSettings({ sel, updateProp, gallery }) {
  if (!sel) return <p style={{ fontSize: 13, color: '#94a3b8' }}>Διάλεξε μπλοκ στον καμβά για ρυθμίσεις.</p>;
  const p = sel.props;
  return (
    <>
      <p style={ptitle}>Ρυθμίσεις: {sel.type}</p>
      {('text' in p) && <Field label="Κείμενο"><textarea value={p.text ?? ''} onChange={e => updateProp('text', e.target.value)} style={{ ...inp, height: 70 }} /></Field>}
      {('label' in p) && <Field label="Κείμενο κουμπιού"><input value={p.label ?? ''} onChange={e => updateProp('label', e.target.value)} style={inp} /></Field>}
      {('url' in p) && <Field label="Σύνδεσμος (link)"><input value={p.url ?? ''} onChange={e => updateProp('url', e.target.value)} style={inp} placeholder="https://..." /></Field>}
      {('name' in p) && <Field label="Όνομα σκάφους"><input value={p.name ?? ''} onChange={e => updateProp('name', e.target.value)} style={inp} /></Field>}
      {('subtitle' in p) && <Field label="Υπότιτλος"><input value={p.subtitle ?? ''} onChange={e => updateProp('subtitle', e.target.value)} style={inp} /></Field>}
      {('address' in p) && <Field label="Διεύθυνση"><input value={p.address ?? ''} onChange={e => updateProp('address', e.target.value)} style={inp} /></Field>}
      {('email1' in p) && <Field label="Email 1"><input value={p.email1 ?? ''} onChange={e => updateProp('email1', e.target.value)} style={inp} /></Field>}
      {('email2' in p) && <Field label="Email 2"><input value={p.email2 ?? ''} onChange={e => updateProp('email2', e.target.value)} style={inp} /></Field>}
      {('phone' in p) && <Field label="Τηλέφωνο"><input value={p.phone ?? ''} onChange={e => updateProp('phone', e.target.value)} style={inp} /></Field>}
      {('website' in p) && <Field label="Website (link)"><input value={p.website ?? ''} onChange={e => updateProp('website', e.target.value)} style={inp} placeholder="https://..." /></Field>}
      {('legal' in p) && <Field label="Νομικό / VAT"><textarea value={p.legal ?? ''} onChange={e => updateProp('legal', e.target.value)} style={{ ...inp, height: 50 }} /></Field>}
      {('cabins' in p) && <div style={{ display: 'flex', gap: 6 }}>
        <Field label="Cabins"><input value={p.cabins ?? ''} onChange={e => updateProp('cabins', e.target.value)} style={inp} /></Field>
        <Field label="WC"><input value={p.wc ?? ''} onChange={e => updateProp('wc', e.target.value)} style={inp} /></Field>
        <Field label="Guests"><input value={p.guests ?? ''} onChange={e => updateProp('guests', e.target.value)} style={inp} /></Field>
      </div>}
      {('price' in p) && <Field label="Τιμή / week (€)"><input value={p.price ?? ''} onChange={e => updateProp('price', e.target.value)} style={inp} /></Field>}
      {('title' in p) && <Field label="Τίτλος"><input value={p.title ?? ''} onChange={e => updateProp('title', e.target.value)} style={inp} /></Field>}
      {('linkLabel' in p) && <Field label="Κείμενο συνδέσμου"><input value={p.linkLabel ?? ''} onChange={e => updateProp('linkLabel', e.target.value)} style={inp} /></Field>}
      {('linkUrl' in p) && <Field label="Σύνδεσμος (link)"><input value={p.linkUrl ?? ''} onChange={e => updateProp('linkUrl', e.target.value)} style={inp} placeholder="https://..." /></Field>}
      {('oldPrice' in p) && <Field label="Αρχική τιμή"><input value={p.oldPrice ?? ''} onChange={e => updateProp('oldPrice', e.target.value)} style={inp} /></Field>}
      {('percent' in p) && <Field label="Έκπτωση %"><input value={p.percent ?? ''} onChange={e => updateProp('percent', e.target.value)} style={inp} /></Field>}
      {('newPrice' in p) && <Field label="Νέα τιμή"><input value={p.newPrice ?? ''} onChange={e => updateProp('newPrice', e.target.value)} style={inp} /></Field>}
      {('width' in p) && <Field label="Πλάτος %"><input type="range" min="20" max="100" value={p.width} onChange={e => updateProp('width', +e.target.value)} style={{ width: '100%' }} /></Field>}
      {('height' in p) && <Field label="Ύψος px"><input type="range" min="8" max="80" value={p.height} onChange={e => updateProp('height', +e.target.value)} style={{ width: '100%' }} /></Field>}
      {(sel.type === 'image' || sel.type === 'yacht' || sel.type === 'hero' || sel.type === 'heroBlank') && (
        <Field label="Φωτό (από γκαλερί)">
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 4 }}>
            {gallery.map(g => <img key={g.url} src={g.url} alt="" onClick={() => updateProp(sel.type === 'image' ? 'url' : 'photoUrl', g.url)} style={{ width: '100%', height: 44, objectFit: 'cover', borderRadius: 4, cursor: 'pointer', border: '1px solid #e2e8f0' }} />)}
          </div>
        </Field>
      )}
    </>
  );
}

function blockPreviewHtml(b) {
  return `<table role="presentation" width="100%" cellpadding="0" cellspacing="0">${renderBlock(b)}</table>`;
}

const ptitle = { fontSize: 13, fontWeight: 700, color: '#0d2840', margin: '0 0 8px' };
const inp = { width: '100%', padding: '8px 10px', border: '1px solid #cbd5e1', borderRadius: 6, fontSize: 13, boxSizing: 'border-box' };
const lbl = { display: 'block', fontSize: 11, fontWeight: 600, color: '#475569', margin: '0 0 3px' };
const btnPrimary = { background: 'linear-gradient(to right,#1e88e5,#0d47a1)', color: '#fff', border: 'none', padding: '9px 18px', borderRadius: 8, fontWeight: 600, cursor: 'pointer' };
const btnSecondary = { background: 'linear-gradient(to right,#b08d57,#8a6d3f)', color: '#fff', border: 'none', padding: '8px 14px', borderRadius: 8, fontWeight: 600, cursor: 'pointer' };
const btnGhost = { background: '#e2e8f0', color: '#334155', border: 'none', padding: '8px 14px', borderRadius: 8, fontWeight: 600, cursor: 'pointer' };
const blockBtn = { display: 'flex', alignItems: 'center', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 8, padding: '10px 12px', fontSize: 13, cursor: 'pointer', textAlign: 'left', color: '#0d2840', fontWeight: 600 };
const ctrlBtn = { background: '#fff', border: '1px solid #cbd5e1', borderRadius: 4, width: 26, height: 26, cursor: 'pointer', fontSize: 13, lineHeight: 1 };
const btnMini = { background: '#e2e8f0', color: '#334155', border: 'none', padding: '5px 10px', borderRadius: 6, fontWeight: 600, cursor: 'pointer', fontSize: 12 };
